var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"core-tree-node-list",class:{ indent: _vm.indent }},_vm._l((_vm.treeNodes),function(treeNode,index){return _c(_vm.componentFor(treeNode),{key:index,tag:"component",attrs:{"tree-node":treeNode}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }